const phishingCanaryWhitelist = {
  en: {
    translation: {
      page_description:
        "Phishing Canary Whitelist is a category of phishing you may have encountered",
      date: "Date",
      domain: "domain",
      original_referrer: "Original Referrer",
      http_headers: "HTTP headers",
      http_headers_missing_tooltip: "No HTTP headers for this incident",
    },
  },
  it: {
    translation: {
      page_description:
        "I Phishing Canary Whitelist sono una categoria di phishing che potresti aver incontrato",
      date: "Data",
      domain: "Dominio",
      original_referrer: "Original Referrer",
      http_headers: "Header HTTP",
      http_headers_missing_tooltip: "Nessun header HTTP per questo incidente",
    },
  },
};

export default phishingCanaryWhitelist;
